import type { IconData } from '@stacksjs/iconify-core'

export const basicUiCheck: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m12 1.5l4 4L6.5 15L0 8.5l4-4L6.5 7z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicUiCheck
